export default __webpack_public_path__ + "static/media/gallery - euphoria_00.ff3daf03.jpg";